module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/headers-styles/header-style2/header-style2.component.scss
// module id = ./src/app/features/headers-styles/header-style2/header-style2.component.scss
// module chunks = main